import { render, staticRenderFns } from "./SeatingInquiry.vue?vue&type=template&id=73e10934&scoped=true"
import script from "./SeatingInquiry.vue?vue&type=script&lang=js"
export * from "./SeatingInquiry.vue?vue&type=script&lang=js"
import style0 from "./SeatingInquiry.vue?vue&type=style&index=0&id=73e10934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e10934",
  null
  
)

export default component.exports